import { useState } from "react";

export const useWindowWidth = (limitSize = 768) => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > limitSize);

  window.addEventListener("resize", () => {
    setIsDesktop(window.innerWidth > limitSize);
  });

  return isDesktop;
};
